// import CountUp from "countup";
import { CountUp } from "countup.js";

class CountUpElement extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }


  init() {
    const originalNum = this.innerText.trim();
    if (!originalNum.match(/[0-9,]+/)) return;

    const prefix = originalNum.match(/[^0-9,.]*/) ? originalNum.match(/[^0-9,.]*/)[0] : '';
    const suffix = originalNum.match(/[^0-9,.]*$/) ? originalNum.match(/[^0-9,.]*$/)[0] : '';
    const parsedNum = originalNum.match(/[0-9,]+/)[0].replace(',','');

    this.countUp = new CountUp(this, parsedNum, {
      duration: 3,
      enableScrollSpy: true,
      prefix,
      suffix,
    });
    if (!this.countUp.error) {
      this.countUp.start();
    }
  }
}

customElements.define("count-up", CountUpElement);
